import store from '@/store/index';

export default {
  // enable/disable camera
  async toggleCamera(state) {
    this.enableVideo = state;
    if (this.localVideoTrack) {
      const isEnabled = state && !this.constraints.screen ? true : false;

      // Pipe the processor lazily when turning the camera on with blur active.
      // This covers the case where the user joined without blur and enabled it
      // while the camera was off, so the processor was never piped at publish
      // time. When turning the camera off we only act on an already-piped
      // processor (nothing to pipe).
      const canUseProcessor = isEnabled && this.videoEffect !== 'none'
        ? this.ensureVbPipelined()
        : this.vbPipelined && this.vbProcessorReady && this.vbProcessor;

      if (canUseProcessor) {
        if (!isEnabled) {
          // Disable processor BEFORE disabling track to avoid corrupted pipeline state
          await this.vbProcessor.disable();
          this.localVideoTrack.getMediaStreamTrack().enabled = false;
        } else {
          // Enable track FIRST, then re-enable processor
          this.localVideoTrack.getMediaStreamTrack().enabled = true;

          if (this.videoEffect !== 'none') {
            this.vbProcessor.setOptions({ type: 'blur', blurDegree: 2 });
            await this.vbProcessor.enable();
          }
        }

        // Refresh the local tile so it reflects the processed (blurred) track.
        // This matters when the camera comes back on with blur active: the
        // published (remote) track is now piped through the processor, but the
        // local tile still holds the stream captured before piping. Committing
        // here keeps the fix self-contained to the Agora adapter so the shared
        // RtcClient / component layer (and the Chime/Skyway adapters) are
        // untouched. getMediaStream swaps in the processed track when
        // vbPipelined is true.
        const rtc = await this.getMediaStream();
        if (rtc && rtc.stream) {
          store.commit('videoRtc/setLocalUserStream', rtc);
        }
      } else {
        this.localVideoTrack.getMediaStreamTrack().enabled = isEnabled;
      }
    }
  }
}
